import { onMounted } from 'vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import useTransactionsStore from '@/store/modules/transactions';
import { usePaymentStore } from '@/store/modules/payment';
import { useAuthStore } from '@/store/modules/auth';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import { Button } from '@yellowcard/components-library-vue3';
import { storeToRefs } from 'pinia';
import { PaymentTypes } from '@/types/payment';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import LoaderComponent from '../general/LoaderComponent.vue';
export default {
    name: 'GenerateWalletDetails',
    components: {
        TransactHeader,
        Button,
        LoaderComponent,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { selectedCrypto, payment, loading, selectedChannel, sequenceId, rates, } = storeToRefs(transactionStore);
        const paymentStore = usePaymentStore();
        const { currentStep } = storeToRefs(paymentStore);
        const authStore = useAuthStore();
        const { sellRedirectLink } = storeToRefs(authStore);
        const payoutAccountsStore = usePayoutAccountsStore();
        const { fromTransaction } = storeToRefs(payoutAccountsStore);
        onMounted(() => {
            fromTransaction.value = false;
            payoutAccountsStore.resetStep();
            payoutAccountsStore.getPayoutAccounts();
        });
        function usdToCryptoValue(crypto, usdAmount) {
            const cryptoRate = rates.value.find(rate => rate.code === crypto)?.sell;
            return usdAmount / (cryptoRate ?? 1);
        }
        function getOnramperCryptoAsset(cryptoCurrency, network) {
            const asset = `${cryptoCurrency}-${network}`.toUpperCase();
            switch (asset) {
                case 'USDT-TRC20':
                    return 'usdt_tron';
                case 'USDT-CELO':
                    return 'usdt_celo';
                case 'USDT-TON':
                    return 'usdt_ton';
                case 'USDT-SOL':
                    return 'usdt_solana';
                case 'USDC-ERC20':
                    return 'usdc_ethereum';
                case 'USDC-CELO':
                    return 'usdc_celo';
                case 'USDC-BASE':
                    return 'usdc_base';
                case 'USDC-SOL':
                    return 'usdc_solana';
                case 'BTC-BTC':
                    return 'btc_ethereum';
                case 'ETH-ERC20':
                    return 'eth';
                case 'CUSD-CELO':
                    return 'cusd_celo';
                case 'SOL-SOL':
                    return 'sol';
                case 'MATIC-POLYGON':
                    return 'matic_polygon';
                case 'MATIC-ERC20':
                    return 'matic_ethereum';
                case 'XAUT-ERC20':
                    return '';
                case 'XAUT-TRC20':
                    return '';
                case 'ADA-CARDANO':
                    return 'ada_cardano';
                case 'PYUSD-ERC20':
                    return 'pyusd_ethereum';
                case 'TON-TON':
                    return 'ton_ton';
                default:
                    return '';
            }
        }
        const showWalletDetails = () => {
            if (!sellRedirectLink.value) {
                currentStep.value = PaymentTypes.SellPaymentSteps.PAYMENT_3;
                sequenceId.value = '';
                return;
            }
            const settlementInfo = payment.value?.settlementInfo;
            if (!settlementInfo?.cryptoAmount ||
                !settlementInfo.cryptoCurrency ||
                !settlementInfo.cryptoNetwork ||
                !settlementInfo.walletAddress) {
                return;
            }
            const searchParams = new URLSearchParams();
            searchParams.append('offramp', 'yellowcard');
            searchParams.append('providerWalletAddress', settlementInfo.walletAddress);
            searchParams.append('transactionId', sequenceId.value);
            searchParams.append('sourceCurrency', getOnramperCryptoAsset(settlementInfo.cryptoCurrency, settlementInfo.cryptoNetwork));
            searchParams.append('targetCurrency', payment.value?.currency?.toLowerCase());
            searchParams.append('inAmount', settlementInfo.cryptoAmount.toString());
            searchParams.append('outAmount', payment.value?.convertedAmount?.toString());
            searchParams.append('paymentMethod', selectedChannel.value === WidgetApiServiceTypes.ChannelTypes.MOMO
                ? 'mobilemoney'
                : 'banktransfer');
            const totalFee = (payment.value?.serviceFeeAmountUSD || 0) +
                (payment.value?.partnerFeeAmountUSD || 0);
            searchParams.append('totalFee', `${usdToCryptoValue(settlementInfo.cryptoCurrency, totalFee)}`);
            const exchangeRate = (settlementInfo.cryptoAmount || 0) /
                (payment.value?.convertedAmount || 1);
            searchParams.append('exchangeRate', exchangeRate.toString());
            sequenceId.value = '';
            window.location.href = `${sellRedirectLink.value}?${searchParams.toString()}`;
        };
        return {
            selectedCrypto,
            showWalletDetails,
            sellRedirectLink,
            payment,
            loading,
        };
    },
};
